import { render, staticRenderFns } from "./UserCertificatesList.vue?vue&type=template&id=7fefa93c"
import script from "./UserCertificatesList.vue?vue&type=script&lang=js"
export * from "./UserCertificatesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports